<template>
  <div>
    <div class="scrolling-wrapper">
      <table class="w-100" style="min-width: 800px;">
        <tr
          v-for="(day, index) in getWeekSchedulerObject(settingsVar)"
          :key="day.id"
          :title="$t(weekDays[index])">
          <td class="align-left headcol">
            <strong class="capitalize">{{ $t(weekDays[index]) | shortDay }}</strong>
          </td>
          <td>
            <timeline
              :key="`timeline-${day.id}-${renderCounter}`"
              :auto-enable="settingsVar.format === 'auto_true_val'"
              :points="day.points"
              :showMarks="index === 0"
              :active-col="activeCol"
              @pos-changed="posChanged"
              @drag-end="dragEnd"
              @dot-click="openModal"
            />
          </td>
        </tr>
      </table>
    </div>
    <set-value-modal
      ref="setValueModal"
      @close="rerender"
      :setting-var="schedulersPointValueSettingVar"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Timeline from '@/components/services/service/scheduler/Timeline.vue';
import { weekDays } from '@/utils/date';
import SetValueModal from '@/components/services/service/scheduler/setValueModal.vue';

export default {
  name: 'ServiceScheduler',
  props: {
    settingsVar: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      renderCounter: 0,
      weekDays,
      activeCol: null,
      schedulersPointValueSettingVar: null,
    };
  },
  computed: {
    ...mapGetters([
      'getWeekSchedulerObject',
    ]),
  },
  methods: {
    posChanged(pos) {
      if (pos === null) {
        this.activeCol = null;
      } else {
        this.activeCol = Math.floor(pos / 4);
      }
    },
    dragEnd() {
      this.activeCol = null;
    },
    openModal(settingsVar) {
      this.schedulersPointValueSettingVar = settingsVar;
      this.$refs.setValueModal.show();
    },
    rerender() {
      this.renderCounter = this.renderCounter + 1;
    },
  },
  filters: {
    shortDay(value) {
      return value.substring(0, 2);
    },
  },
  components: {
    SetValueModal,
    Timeline,
  },
};
</script>


<style lang="scss" scoped>

  table {
    border-collapse: separate;
    border-spacing: 0;

    td {
      width: 95%;
      padding: 0;
      margin: 0;
      white-space: nowrap;

      &.headcol {
        width: 5%;
        vertical-align: bottom;
        /* position: absolute; */
      }
    }
  }

.scrolling-wrapper {
  overflow: auto;
  white-space: nowrap;
  padding: 40px 0 30px 0;
}
</style>
